<script>
import SelectionStatsCard from './SelectionStatsCard.vue';
import SelectionHistoryStats from './SelectionHistoryStats.vue';
export default {
  name: 'SelectionFullForm',
  components: {
    SelectionStatsCard,
    SelectionHistoryStats,
  },
  props: {
    selection: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // only return records with results
    // added extra check to make sure competitor is not scratched
    // add another check to hide abandoned events
    formRecords() {
      const { records } = this.selection;
      const { isCompetitorScratched, isEventAbandoned } = this;
      return records
        ? records.filter(item => !isEventAbandoned(item) && item.results.length > 0 && !isCompetitorScratched(item))
        : [];
    },
  },
  methods: {
    isCompetitorScratched(record) {
      const { selection } = this;
      const { selections } = record;
      const scratchedArray = selections
        ? selections.filter(item => item.competitor_id === selection.competitor_id && item.status === 'scratched')
        : [];
      return scratchedArray.length > 0;
    },
    isEventAbandoned(event) {
      return event.status === 'Abandoned';
    },
  },
};
</script>

<template>
  <div class="selection-full-form">
    <SelectionStatsCard :selection="selection" />
    <template v-if="formRecords.length > 0">
      <SelectionHistoryStats
        v-for="(record, index) in formRecords"
        :key="index"
        :competitor-id="selection.competitor_id"
        :record="record"
      />
    </template>
  </div>
</template>
